import { useCallback, useState } from "react";

export const useNFCDialogState = ({ setEvent, startScanning, stopScanning }) => {
    const [open, setOpen] = useState(false);
    const openDialog = useCallback(() => {
        setEvent();
        startScanning();
        setOpen(true);
    }, [startScanning]);
    const closeDialog = useCallback(() => {
        stopScanning();
        setOpen(false);
    }, [stopScanning]);

    return [open, openDialog, closeDialog];
};
